import { render, staticRenderFns } from "./MatterNotesDocs.vue?vue&type=template&id=696a2afa"
import script from "./MatterNotesDocs.vue?vue&type=script&lang=js"
export * from "./MatterNotesDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports